import React from 'react';
import { fileArchiveTypeAtom } from '../Shared/file.archive.type';
import { useAtom } from 'jotai';
import CustomizableSelect from 'Global/Components/CommonComponents/CustomizableSelect/CustomizableSelect';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';

export default function FileTypeCombo({ setFromProps }) {
  const [fileArchiveType] = useAtom(fileArchiveTypeAtom);
  const dataArray = fileArchiveType?.map((el) => ({
    ItemContent: ArabicToPersian(el.Name),
    ItemValue: el.Id,
  }));

  const fileType_label = FindLangKey(
    'genral-public-label-select-file-type'
  );

  return (
    <>
      <CustomizableSelect
        SelectableDataArray={dataArray}
        label={fileType_label}
        isSingle={true}
        GetSelectedValue={(val) => {
          setFromProps((prev) => ({
            ...prev,
            NameType: val.ItemContent,
            IdType: val.ItemValue,
          }));
        }}
      />
    </>
  );
}
